/**
 * @author silence
 * @desc:注册登录页面请求借口
 * */

import request from '@/utils/ajax';

export function getSendVerEmail(data) {
	return request({
		url: 'crm/auth/reception/sendVerEmail',
		method: 'get',
		params:data,
	});
}
export function getSendVerWallet(data) {
  return request({
    url: 'crm/reception/update/wallet',
    method: 'get',
    addToken:true,
    params:data,
  });
}

export function RegisterPost(data) {
	return request({
	    url: 'crm/auth/fp/reg',
        method: 'POST',
		data,
	});
}

export function checkCommUserExist(params) {
	return request({
	    url: '/crm/reception/checkCommUserExist',
        method: 'get',
		params,
	});
}

export function createMTAcc4Community(params) {
	return request({
	    url: '/crm/reception/createMTAcc4Community',
        method: 'get',
		params,
	});
}

///auth/reception/activeReg
export function activeReg(params) {
	return request({
	    url: '/crm/auth/reception/activeReg',
        method: 'get',
		params,
	});
}
//重发注册激活邮件
export function retryRegActiveEmail(params) {
	return request({
	    url: '/crm/reception/retryRegActiveEmail',
		method: 'get',
		addToken:true,
		params,
	});
}



export function OpenApply(data) {
	return request({
	    url: '/crm/reception/tCustInfo/apply',
        method: 'POST',
		data,
		addToken:true,
	});
}

export function LoginPost(data) {
	return request({
	    url: '/crm/auth/fp/login',
        method: 'POST',
		data,
	});
}

export function UploadImg64(data) {
	return request({
	    url: '/crm/file/uploadBase64Picture',
        method: 'POST',
		data,
	});

}

export function forgetVerification(data) {
	return request({
	    url: '/crm/reception/cust/sendVer',
        method: 'Post',
        data,
	});
}

export function forgetSubmit(data) {
	return request({
	    url: '/crm/reception/forgetPwd',
        method: 'Post',
        data,
	});
}

export function commitBankcard(data) {
	return request({
	    url: '/crm/reception/personalDoc/commitBankcard',
        method: 'Post',
        data,
	});
}

export function commitBankcardImg(data) {
	return request({
	    url: '/crm/reception/personalDoc/commitBankcard',
        method: 'Post',
		data,
		addToken:true,
	});
}

export function commitAddressImg(data) {
	return request({
	    url: '/crm/reception/personalDoc/commitAddress',
        method: 'Post',
		data,
		addToken:true,
	});
}

export function commitIdentifyImg(data) {
	return request({
	    url: '/crm/reception/personalDoc/commitIdentify',
        method: 'Post',
		data,
		addToken:true,
	});
}

export function modifyMTAlias(data) {
	return request({
		url: '/crm/reception/personal/modifyMTAlias',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

/*/crm/reception/commitMsg
POST
请求参数：
custId - 客户ID
name - 姓名
nation - 国家
email - 邮箱
phone - 电话
convenientTime - 方便的通话时间
content - 内容*/

export function callmeSubmit(data) {
  return request({
    url: '/crm/reception/commitMsg',
    method: 'POST',
    data: data,
  });
}
/*申请设立地区办事处
/crm/reception/commitOfficeApp
POST
请求参数：
custId - 客户ID
name - 姓名
email - 邮箱
regional - 地区
cooperExp - 合作经验
workplace - 办公场所描述
workplaceImg - 办公场所图片
workplaceImg2 - 办公场所图片2
workplaceImg3 - 办公场所图片3*/
export function commitOfficeApp(data) {
  return request({
    url: '/crm/reception/commitOfficeApp',
    method: 'POST',
    data: data,
  });
}

// 查询产品合约细则条件： /crm/reception/getProductrulesCondition

export function queryContractList() {
  return request({
    url: '/crm/reception/getProductrulesCondition',
    method: 'GET',
  });
}
// 获取合约细则
/*
*
* userGroup
* symbolGroup
* baseCurrency
* quoteCurrency
* page
* size
* */
export function getContractTable(data) {
  return request({
    url: '/crm/reception/getProductrules',
    method: 'GET',
    params: data,
  });
}

export function initData(url, params, isNeedToken) {
	return request({
		url: url,
		method: 'get',
		params,
		addToken:isNeedToken,
	})
}

export function commissionInitData(url, data, isNeedToken) {
  return request({
    url: url,
    method: 'post',
    data: data,
    addToken:isNeedToken,
  })
}

export function queryHasActivity(data) {
	return request({
		url: '/crm/fp/tCustBonusRule',
		method: 'GET',
		params: data,
	});
}


export function queryActivityDetail(data) {
	return request({
		url: '/crm/fp/queryRecord',
		method: 'GET',
    params: data,
	});
}



export function getTradeHistoryAccountList(data) {
  return request({
    url: 'crm/reception/queryRecordLogin',
    method: 'GET',
    params: data,
    addToken:true,
  });
}

/**
 * 根据赠金记录id查询开户赠金记录的盈利信息
 url:/crm/reception/queryrecordInfo
 请求方式:get
 参数：
 id：必须 赠金记录id
 返回
 balance：总余额
 profit：盈利
 */
export function queryrecordInfo(data) {
  return request({
    url: '/crm/reception/queryrecordInfo',
    method: 'GET',
    params: data,
    addToken:true,
  });
}

// 消息列表
export function queryNotice(data) {
  return request({
    url: '/crm/reception/notice',
    method: 'GET',
    params: data,
    addToken:true,
  });
}


export function readAllNotice(data) {
  return request({
    url: `/crm/reception/readAll/${data.custId}`,
    method: 'put',
    addToken:true,
  });
}


/*
* 读所有的公共
* */
export function readAllPopUpNotice(data) {
  return request({
    url: `/crm/reception/readAllPopUpNotice/${data.custId}`,
    method: 'put',
    addToken:true,
  });
}

export function getCustPayTypes(data) {
  return request({
    url: 'crm/reception/getCustPayTypes',
    method: 'get',
    addToken:true,
    params: data,
  });
}

export function updateUsdtOrOtcInfo(data) {
  return request({
    url: 'crm/reception/updateCustPayType',
    method: 'put',
    addToken:true,
    data,
  });
}

// 公告查询接口
export function queryAnnouncement(data) {
  return request({
    url: 'crm/reception/getPublicNotice',
    method: 'get',
    addToken:true,
    params:data,
  });
}

// 通知弹框查询
export function queryNoticeDialog(data) {
  return request({
    url: 'crm/reception/getPopUpNotice',
    method: 'get',
    addToken:true,
    params:data,
  });
}

// 通知弹框已读
export function readNoticeDialog(data) {
  return request({
    url: 'crm/reception/readPopUpNotice',
    method: 'post',
    addToken:true,
    data,
  });
}


export function getVerifiedInfo(data) {
  return request({
    url: 'crm/reception/getVerifiedInfo',
    method: 'get',
    addToken:true,
    params: data,
  });
}

export function activeUseCode(data) {
  return request({
    url: `crm/auth/reception/activeRegByCode/${data.activeCode}`,
    method: 'put',
    addToken:true,
  });
}


export function cancelWithdraw(id) {
  return request({
    url: `crm/reception/cancelWithdraw/${id}`,
    method: 'put',
    addToken:true,
  });
}

export function cancelCommission(id) {
  return request({
    url: `crm/reception/cancelCommission/${id}`,
    method: 'put',
    addToken:true,
  });
}




export function getDictValueApi(data) {
  return request({
    url: 'crm/fp/dict',
    method: 'get',
    addToken:true,
    params: data,
  });
}



